import { action, intercept, makeObservable, observable } from 'mobx'
import { IValidationSchema, required, validationContext } from 'validx'
import { PersonalInfo } from '@taxfyle/api-internal/internal/individual_profile_pb'
import {
  maxLength,
  mustBeInThePast,
  mustBeValidPersonalTaxpayerIdentificationNumber,
  mustBeValidTaxFormInputValue,
} from 'utils/validation-utils'

export default class PersonalInfoEditorViewModel {
  @observable firstName = ''

  @observable middleInitial = ''

  @observable lastName = ''

  @observable dateOfBirth = ''

  @observable personalTaxpayerIdentificationNumber = ''

  private schema: IValidationSchema<this> = {
    firstName: [
      required('First name is required'),
      mustBeValidTaxFormInputValue(),
      maxLength(100, 'First name must not exceed 100 characters'),
    ],
    middleInitial: [
      maxLength(1, 'Middle initial must be a single character'),
      mustBeValidTaxFormInputValue(),
    ],
    lastName: [
      required('Last name is required'),
      mustBeValidTaxFormInputValue(),
      maxLength(100, 'Last name must not exceed 100 characters'),
    ],
    dateOfBirth: [
      required('Date of birth is required'),
      mustBeInThePast('Date of birth must be in the past'),
    ],
    personalTaxpayerIdentificationNumber: [
      required('SSN/ITIN is required'),
      mustBeValidPersonalTaxpayerIdentificationNumber(),
    ],
  }

  validation = validationContext(this)

  constructor() {
    makeObservable(this)

    intercept(this, (change) => {
      this.validation.clearErrors(String(change.name))
      return change
    })
  }

  @action.bound
  validate() {
    return this.validation.reset().validate(this.schema).isValid
  }

  @action
  reset(info?: PersonalInfo.AsObject) {
    this.firstName = info?.firstName ?? ''
    this.middleInitial = info?.middleInitial ?? ''
    this.lastName = info?.lastName ?? ''
    this.dateOfBirth = info?.dateOfBirth ?? ''
    this.personalTaxpayerIdentificationNumber =
      info?.personalTaxpayerIdentificationNumber ?? ''
    this.validation.reset()
  }

  toPersonalInfo(): PersonalInfo.AsObject {
    return {
      firstName: this.firstName,
      middleInitial: this.middleInitial,
      lastName: this.lastName,
      dateOfBirth: this.dateOfBirth,
      personalTaxpayerIdentificationNumber:
        this.personalTaxpayerIdentificationNumber,
    }
  }
}
